import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import styles from '../ForInvestors.module.scss';
import ClippedImage from 'common/components/ClippedImage/ClippedImage';
import messages from '../ForInvestors.intl';
import ContentStore from 'stores/Content.store';

@injectIntl
@observer
export default class ContactForInvestors extends Component {
  render() {
    const { content } = ContentStore;
    const { ForInvestorsContact: contact } = content;

    return (
      <div className={styles.ContactForInvestors}>
        <h1>{this.props.intl.formatMessage(messages.contactTitle)}</h1>
        <div className={styles.ContactWrapper}>
          <div className={styles.ContactPersona}>
            <div>
              {contact.photo && (
                <ClippedImage
                  id="1"
                  width={110}
                  height={130}
                  borderWidth={'1'}
                  url={contact.photo}
                />
              )}
            </div>
            <div className={styles.ContactPersonaNameAndPosition}>
              <span className={styles.ContactPersonaFullName}>
                {contact.fullName}
              </span>
              <span className={styles.ContactPersonaPosition}>
                {contact.position}
              </span>
            </div>
          </div>

          <div className={styles.ContactDetails}>
            <div className={styles.ContactDetailsPhoneNumber}>
              {contact.phoneNumber &&
                `${this.props.intl.formatMessage(messages.contactTel)} ${
                  contact.phoneNumber
                }`}
            </div>
            <div className={styles.ContactDetailsEmail}>{contact.email}</div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ForInvestors/components/ContactForInvestors.js